var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "80px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t@keyframes expandRetract {\r\n  0%, 100% {\r\n    transform: scale(1); /* Original size */\r\n  }\r\n  10% {\r\n    transform: scale(1.1); /* Expand */\r\n  }\r\n  90% {\r\n    transform: scale(0.9); /* Retract a bit */\r\n  }\r\n}\r\n.st01{\r\n\tfill:#ffffff;\r\n}\r\n\r\n#_x32_ {\r\n  animation: expandRetract 8s infinite;\r\n}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M256.004,0C114.8,0.008,0.025,114.801,0,255.996C0.025,397.183,114.8,511.975,256.004,512 C397.191,511.975,511.984,397.183,512,255.996C511.984,114.801,397.191,0.008,256.004,0z M420.735,420.72 c-42.256,42.241-100.456,68.354-164.731,68.362c-64.284-0.008-122.491-26.121-164.732-68.362 c-42.24-42.241-68.345-100.456-68.354-164.724c0.008-64.276,26.114-122.475,68.354-164.731 C133.513,49.04,191.72,22.927,256.004,22.918c64.276,0.008,122.475,26.122,164.731,68.346 c42.224,42.256,68.338,100.447,68.346,164.731C489.073,320.264,462.96,378.479,420.735,420.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M72.03,173.859h-1.445c-11.141,25.118-17.37,52.885-17.37,82.137c0,79.817,46.109,148.821,113.138,181.918 L72.039,173.859H72.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M371.166,182.392c-17.484-24.452-14.891-74.438,17.26-79.914c-35.538-30.672-81.8-49.272-132.421-49.272 c-71.894,0-135.006,37.432-171.017,93.857h74.23v26.795h-29.919l69.269,193.887l48.59-129.884l-22.878-64.004h-34.607v-26.795 h124.225v26.795h-32.358l69.855,195.573l35.401-94.572C393.073,249.366,389.404,207.967,371.166,182.392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M444.513,181.277c-0.08,0.77-0.16,1.549-0.273,2.304c-4.905,32.92-35.394,105.127-35.394,105.127 l-44.143,117.996l-9.849,26.346c62.004-34.686,103.939-100.946,103.939-177.054C458.794,229.594,453.696,204.404,444.513,181.277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M211.861,404.962l-16.665,44.537c19.202,6.036,39.616,9.287,60.808,9.287c23.16,0,45.388-3.925,66.122-11.086 l-61.675-172.654L211.861,404.962z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/WORDPRESS.0bfef1d8bf2e28c3b5e46eb241cda0cb.svg";
export { ForwardRef as ReactComponent };